import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=eff22768&scoped=true"
import script from "./BaseLabel.vue?vue&type=script&lang=ts"
export * from "./BaseLabel.vue?vue&type=script&lang=ts"
import style0 from "./BaseLabel.vue?vue&type=style&index=0&id=eff22768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff22768",
  null
  
)

export default component.exports